import { render, staticRenderFns } from "./zhichu.vue?vue&type=template&id=b57bc1e2&scoped=true&"
import script from "./zhichu.vue?vue&type=script&lang=js&"
export * from "./zhichu.vue?vue&type=script&lang=js&"
import style0 from "./zhichu.vue?vue&type=style&index=0&id=b57bc1e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57bc1e2",
  null
  
)

export default component.exports